import React from 'react';
import styled from 'react-emotion';
import { Link } from 'react-router-dom';
import {
  Typography,
  Button,
} from 'material-ui';

import { PATHS as paths } from '../lib/constants';

const Container = styled('div')`
  width: 100vh;
  height: 100vh;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const InnerContainer = styled('div')`
  height: 300px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`

export const NotFound = () => (
  <Container>
    <InnerContainer>
      <Typography type='display3'>
        Oh No!
      </Typography>
      <Typography type='body1'>
        We couldn't find a page for <code>{window.location.pathname}</code>
      </Typography>
      <br />
      <Button raised color="primary" component={Link} to={paths.root}>
        Take Me Home
      </Button>
    </InnerContainer>
  </Container>
);


// WEBPACK FOOTER //
// ./src/components/NotFound.jsx